export function accommodationItemsMapping(items: string[]): string[] {
    const groups: Record<string, string[]> = {
        Hotel: ['Hotel', 'Jurte', 'Boot'],
        Zelt: ['Zelt'],
    };

    const result: string[] = [];
    const addedGroups = new Set<string>();

    for (const item of items) {
        const groupName = Object.keys(groups).find(group =>
            groups[group].includes(item)
        );

        if (groupName && !addedGroups.has(groupName)) {
            result.push(groupName);
            addedGroups.add(groupName);
        }
    }

    return result;
}
